import { RetryLink } from '@apollo/client/link/retry'

const link = new RetryLink()
export default link
